export default {
  title: "Tunggakan"
};
